import { Component, OnInit } from '@angular/core';
import { DistributorEditFormComponent } from './distributor-edit-form/distributor-edit-form.component';
import { DistributorRegionFormComponent } from './distributor-region-form/distributor-region-form.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DataTableComponent } from '../datatable/datatable.component';
import { AppService } from '../../services/app.service';
import { DistributorService } from '../../services/distributor.service';
import { Datatable } from '../../models/datatable.model';
import { SharedService } from '../../services/shared';  
import { Router } from '@angular/router';

@Component({
selector: 'app-distributor',
templateUrl: './distributor.component.html',
styleUrls: ['./distributor.component.scss']
})
export class DistributorComponent implements OnInit {
public data;
editFormDialogRef: MatDialogRef<DistributorEditFormComponent>;
regionFormDialogRef: MatDialogRef<DistributorRegionFormComponent>;
public length;
translations: any;
pageIndex: Number = 0;
pageSize: Number = 10;
filterText: String = '';
sortDirection: String = 'asc';
sortHeaderName: String = 'Code';
sortColumnNameById: String = 'Id';
pagingDetails: any = null;
isRedirectedFromDistributor = false; 

constructor(
private distributorService: DistributorService,
public appService: AppService,
private datatableComponent: DataTableComponent,
public dialog: MatDialog,
private datatableProp: Datatable,
private sharedService: SharedService,
private router: Router
) {
    this.setPageTranslations();
    this.appService.showLoading();
    this.appService.checkSession();
    if(this.isRedirectedFromDistributor){
      this.pagingDetails = JSON.parse(sessionStorage.getItem('pagingDetails'));
      this.pageIndex = this.pagingDetails.pageIndex;
      this.pageSize = this.pagingDetails.pageSize;
      this.sortColumnNameById = this.pagingDetails.sortColumnNameById;
      this.sortDirection = this.pagingDetails.sortDirection;
      this.filterText = this.pagingDetails.filterText;
    }
    this.getDistributors();
}

setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
}

ngOnInit() {
}

getDistributors(): void {
  this.appService.showLoading();
  this.distributorService.all(this.pageIndex,this.pageSize,this.sortColumnNameById,this.sortDirection,this.filterText).subscribe(
    res => this.getAllDistributorSuccess(res),
    error => this.apiFaillure(error)
  );
}

getAllDistributorSuccess(res): void {
    this.data = [];
    if (res.Status == 1) {
    this.data = JSON.parse(res.Data).Table;
    this.datatableProp = this.appService.mapDataTableProp(this.datatableProp,JSON.parse(res.Data).Table1[0]);      
    this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
    this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
    this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
    this.sharedService.Data.next(this.data);
    this.appService.hideLoading();
    } else if (res.Status == -1) {
    this.apiFaillure(res.Message);
    }
}
apiFaillure(error): void {
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
}

editRecord(e): void {
    this.editFormDialogRef = this.dialog.open(DistributorEditFormComponent, {
    disableClose: true,
    data: {
    Id: e.currentTarget.id
    },
    panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
    .subscribe((response) => {   
    this.appService.showLoading();    
    this.data = '';
    this.datatableProp = new Datatable();
    //this.setDatatableColumns();
    this.getDistributors();
    });
}

setDatatableColumns(){
    this.datatableProp = new Datatable();
    this.datatableProp.isEdit = false;
    this.datatableProp.isAdd = false;
    this.datatableProp.isDelete = false;
}

deleteRecord(e): void {
    var distributionId = e.currentTarget.id;
     this.appService.showDialogue(this.translations.hdConfirm, this.translations.confrimMessage,true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.appService.showLoading();
        this.deleteConfirm(distributionId);
      }          
    });
  }
  
  deleteConfirm(distributionId){
     this.distributorService.delete(distributionId).subscribe(
      res => this.deleteSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  
  deleteSuccess(res){
   if (res.Status == 1){
        this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
        .afterClosed().subscribe(result => {
            if (result) {                     
            this.appService.hideLoading();
            this.data = '';
            this.datatableProp = new Datatable();
            this.getDistributors();
            }          
        });        
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }    
  }

addRecord(): void {
    this.editFormDialogRef = this.dialog.open(DistributorEditFormComponent, {
    disableClose: true,
    data: {
    Id: 0
    },
    panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
    .subscribe((response) => {
    this.appService.showLoading();    
    this.data = '';
    this.datatableProp = new Datatable();
    this.getDistributors();
    });
 }

 changeAccess(e){
    console.log(e);
    var id = e.target.getAttribute('id');
    var action = e.target.getAttribute('class');
    console.log('btn-classes : ' + action);
    if(action.indexOf('api-user') > -1){
      this.isRedirectedFromDistributor = true;
      this.pagingDetails = { pageIndex: this.pageIndex, 
        pageSize : this.pageSize, 
        sortColumnNameById: this.sortColumnNameById, 
        sortDirection: this.sortDirection, 
        filterText: this.filterText
      };
      sessionStorage.setItem('pagingDetails', JSON.stringify(this.pagingDetails));
      this.router.navigate(['/apiuserdetails']);
    }
    else
    {
      this.regionFormDialogRef = this.dialog.open(DistributorRegionFormComponent, {
        disableClose: true,
        data: {
          Id: id
        },
        panelClass: 'my-dialog'
      });
      this.regionFormDialogRef.afterClosed()
        .subscribe((response) => {
          this.appService.showLoading();
          this.data = '';
          this.getDistributors();
        });  
    }
  }  
  
  getServerData(event){
    this.datatableProp = new Datatable();
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getDistributors();
 }
 applyFilter(filterValue: any){
    this.datatableProp = new Datatable();
    this.filterText = filterValue;
    this.getDistributors();
 }
 getSortedData(event){
    this.datatableProp = new Datatable();
    this.sortColumnNameById = event.currentTarget.getAttribute('id');
    this.getDistributors();
 }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/distributor.component.ts